import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px (past hero roughly)
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-237">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-4 left-4 right-4 z-50 md:hidden" data-id="element-238">
          <button onClick={scrollToOffer} className="w-full bg-brand-green text-white font-heading font-bold py-4 px-6 rounded-xl shadow-2xl flex items-center justify-center gap-2 text-lg border-2 border-brand-gold/20" data-id="element-239">
            Empezar mi plan
          </button>
        </motion.div>}
    </AnimatePresence>;
}